<template>
  <div
    class="programs"
    id="programs"
    data-testid="elem_u_003032"
  >
    <p
      class="programs-title"
      data-testid="elem_u_003033"
    >
      Our programs
    </p>
    <p
      class="description"
      data-testid="elem_u_003034"
    >
      A great variety of programs at the tip of your fingers! If you don't like what you see, hit us
      up and we'll gladly make a deal happen.
    </p>

    <div
      class="programs-grid"
      data-testid="elem_u_003035"
    >
      <div
        class="one-program revenue"
        data-testid="elem_u_003042"
      >
        <p
          class="program-title"
          data-testid="elem_u_003043"
        >
          Revenue share
        </p>
        <div
          class="percents-container"
          data-testid="elem_u_003044"
        >
          <span
            class="percents"
            data-testid="elem_u_003045"
            >65%</span
          >
          <span
            class="per-smth"
            data-testid="elem_u_003046"
            >/lifetime</span
          >
        </div>
        <div
          class="program-description"
          data-testid="elem_u_003047"
        >
          Earn up to 65% of every membership you send our way for the life of the member. Our
          members retain!
        </div>
      </div>
      <div
        class="one-program pay-per-sign-up"
        data-testid="elem_u_003048"
      >
        <p
          class="program-title"
          data-testid="elem_u_003049"
        >
          Pay per sign up
        </p>
        <div
          class="percents-container"
          data-testid="elem_u_003050"
        >
          <span
            class="percents"
            data-testid="elem_u_003051"
            >$30</span
          >
          <span
            class="per-smth"
            data-testid="elem_u_003052"
            >/sign up</span
          >
        </div>
        <div
          class="program-description"
          data-testid="elem_u_003053"
        >
          Get paid $30 for every trial and full sign up you send to VR Bangers. It's simple as that!
        </div>
      </div>
      <div
        class="one-program total"
        data-testid="elem_u_003054"
      >
        <div
          class="total-item"
          data-testid="elem_u_003055"
        >
          <p
            class="total-value"
            data-testid="elem_u_003056"
          >
            $15,000,000+
          </p>
          <span
            class="total-description"
            data-testid="elem_u_003057"
          >
            The total payout since 2018
          </span>
        </div>
        <div
          class="total-item"
          data-testid="elem_u_003058"
        >
          <p
            class="total-value"
            data-testid="elem_u_003059"
          >
            2,000+
          </p>
          <span
            class="total-description"
            data-testid="elem_u_003060"
          >
            Affiliates already earn with us
          </span>
        </div>
        <div
          class="total-item"
          data-testid="elem_u_003061"
        >
          <p
            class="total-value"
            data-testid="elem_u_003062"
          >
            {{ numberOfSites }}
          </p>
          <span
            class="total-description"
            data-testid="elem_u_003063"
          >
            VR websites
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Programs',

  props: {
    numberOfSites: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.programs {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  padding-bottom: 100px;

  @media (max-width: 1660px) {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  @include sm-down {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}

.programs-title {
  font-size: 42px;
  font-weight: 700;
  line-height: 49px;
  color: var(--color-grey-280);
  margin-bottom: 20px;

  @media (max-width: 1660px) {
    font-size: 30px;
    line-height: 35px;
  }

  @include sm-down {
    font-size: 24px;
    line-height: 28px;
  }
}

.description {
  font-size: 20px;
  font-weight: 400;
  line-height: 23px;
  margin-bottom: 50px;
  color: var(--color-grey-500);
  background-color: transparent;

  @include md-down {
    font-size: 16px;
    line-height: 19px;
  }

  @include sm-down {
    margin-bottom: 30px;
  }
}

.programs-grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
  row-gap: 20px;

  @include md-down {
    grid-template-columns: 100%;
  }
}

.one-program {
  padding: 50px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-radius: 25px;
  color: var(--color-grey-280);

  @include sm-down {
    padding: 20px;
  }
}

.program-title {
  margin: 0;
  padding: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;

  @media (max-width: 1660px) {
    font-size: 18px;
    line-height: 21px;
  }
}

.percents-container {
  display: flex;
  align-items: center;
  gap: 10px;
  height: fit-content;

  .percents {
    font-size: 60px;
    font-weight: 500;
    line-height: 70px;

    @media (max-width: 1660px) {
      font-size: 38px;
      line-height: 45px;
    }

    @include sm-down {
      font-size: 28px;
      line-height: 33px;
    }
  }

  .per-smth {
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
  }
}

.program-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
}

.total-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.total-value {
  margin: 0;
  padding: 0;
  font-size: 24px;
  font-weight: 900;
  line-height: 28px;

  @include md-down {
    font-size: 20px;
    line-height: 23px;
  }
}

.total-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: var(--color-grey-500);
}

.revenue {
  background: linear-gradient(317deg, #6484f4 -178.88%, rgba(100, 132, 244, 0) 101.67%);
}

.pay-per-sign-up {
  background: linear-gradient(317deg, #64f484 -178.88%, rgba(100, 244, 132, 0) 101.67%);
}

.total {
  background: linear-gradient(317deg, #9f9f9f -178.88%, rgba(217, 217, 217, 0) 101.67%);
  justify-content: center;

  @include md-down {
    padding-top: 45.5px;
    padding-bottom: 45.5px;
  }
  @include sm-down {
    padding: 20px;
  }
}
</style>
